

























import InputField from "./InputField";
import { Contact } from "../../models/Contact";
import Multiselect from "vue-multiselect";
import { ContactApi } from "../../api/ContactApi";
import { Config } from "../../utils/Config";

export default {
    name: "ContactSelect",
    components: { InputField, Multiselect },
    props: {
        label: String,
        value: Contact,
        filterTypes: Array,
        placeholder: String,
        appUsersOnly: Boolean,
    },
    data() {
        return {
            ContactApi: new ContactApi(),
            selected: null,
            options: [],
            vueMultiselectParams: _.merge(Config.vueMultiselectParams, {
                selectLabel: "",
            }),
        };
    },
    created() {
        let self = this;
        // Liste complète attendue : limite explicite (la même que l'app
        // mobile) ; useCache partage la réponse entre les sélecteurs.
        self.ContactApi.getAll({
            types: _.join(self.filterTypes, ","),
            include: "related_contacts",
            useCache: true,
            limit: 100000,
        }).then(function (res) {
            self.options = res.data;
            if (self.appUsersOnly) {
                self.options = _.filter(self.options, "has_users");
            }
        });
        self.selected = self.value;
    },
    methods: {
        hasInputGroupAddon: function () {
            return !!this.$slots.inputGroupAddon;
        },
    },
    watch: {
        selected: function () {
            this.$emit("input", this.selected);
        },
    },
};
